import { Link } from 'react-router-dom';
import type { CatalogItem } from '../types';

const rarityTone: Record<string, string> = {
  Mythical: 'rarity-mythical',
  Legendary: 'rarity-legendary',
  Rare: 'rarity-rare',
  Uncommon: 'rarity-uncommon',
  Common: 'rarity-common',
  Default: 'rarity-default',
};

export function CatalogItemCard({ item }: { item: CatalogItem }) {
  return (
    <Link to={`/items/${encodeURIComponent(item.item_key)}`} className="item-card">
      <div className="item-card__media">
        {item.image_url ? (
          <img src={item.image_url} alt={item.name} loading="lazy" className="item-card__image" />
        ) : (
          <span className="item-card__emoji">{item.type === 'Gem' ? '💎' : '🔨'}</span>
        )}
      </div>

      <div className="item-card__body">
        <div className="item-card__header">
          <h3>{item.name}</h3>
          <span className={`rarity-pill ${rarityTone[item.rarity || 'Default'] || 'rarity-default'}`}>
            {item.rarity || 'Default'}
          </span>
        </div>

        <div className="item-card__meta">
          <span>{item.type || 'Unknown'}</span>
          <span>{item.category || 'Base'}</span>
        </div>

        <div className="item-card__stats">
          <div>
            <strong>{item.owners.toLocaleString()}</strong>
            <span>owners</span>
          </div>
          <div>
            <strong>{item.copies.toLocaleString()}</strong>
            <span>copies</span>
          </div>
        </div>
      </div>
    </Link>
  );
}
